import React from "react";

/**
 * component svg 
 */
const NoFilters = function (props) {

    return (
        <svg version="1.1" id="no-filters" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	    viewBox="0 0 1000 1000">
            <polyline className="st0-no-filters" points="927.7,149.1 948.9,123.8 915.9,123.8 		"/>
            <line className="st1-no-filters" x1="806.2" y1="123.8" x2="138.9" y2="123.8"/>
            <polyline className="st0-no-filters" points="84.1,123.8 51.1,123.8 72.3,149.1 		"/>
            <path className="st2-no-filters" d="M136.4,225.6l260.1,310.2c11.4,13.6,17.7,30.8,17.7,48.6v271.2c0,37.9,30.8,68.7,68.7,68.7h34.3
                c37.9,0,68.7-30.8,68.7-68.7V584.3c0-17.8,6.3-35,17.7-48.6l292.1-348.4"/>
        </svg>
    );
};

export default NoFilters;